import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import {
  ResetPassSetInitGetRequestModel,
  ResetPassSetInitGetResponseModel
} from "@/features/user/services/reset-pass-set-model";

export class ResetPassSetApi {
  /**
   * パスワードリセット パスワード設定ページ表示前処理API
   */
  public resetPassSetInit = async (
    param: ResetPassSetInitGetRequestModel
  ): Promise<ResetPassSetInitGetResponseModel> => {
    const path = `/api/reset_pass_set/init`;

    const res = await ApiClient.instance.get<ResetPassSetInitGetResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
